import * as React from "react";
import PropTypes from "prop-types";
import SharedPropTypes from "../../Swap/modules/SharedPropTypes";

export default class ChooseSwap extends React.PureComponent {

  static propTypes = {
    "classes": PropTypes.string,
    "onSwap": PropTypes.func.isRequired,
    "productDescriptor": SharedPropTypes.productDescriptor.isRequired,
    "productDescriptors": SharedPropTypes.productDescriptors,
    "text": PropTypes.string.isRequired
  };

  static defaultProps = {
    "classes": "",
    "productDescriptors": null
  };

  handleClick = () => {
    const {onSwap, productDescriptor} = this.props;
    onSwap(productDescriptor);
  };

  isSwapped = () => {
    const {productDescriptor, productDescriptors} = this.props;
    for (const key in productDescriptors) {
      if (productDescriptors[key].id === productDescriptor.id) return true;
    }
    return false;
  }

  render () {
    const {classes, text} = this.props;
    if (this.isSwapped()) {
      return (
        <a
          className={`btn btn-tertiary disabled centered ${classes}`}
        >
          Selected
        </a>
      );
    }
    return (
      <a
        className={`btn ${classes}`}
        onClick={this.handleClick}
      >
        {text}
      </a>
    );
  }
}
